import {
  QUERY_RESPONSE_RECEIVED,
  MUTATION_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import {
  SONAR_V3_ALPHA_CREATE_SESSION,
  SONAR_V3_CREATE_SESSION,
  SONAR_V3_POLL,
  SONAR_V3_POLL_ALPHA,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import { isSonarV3ErrorPayload } from '@web-platform/shared-universal-utils-frontend/src/helpers/isSonarErrorPayload';
import keyBy from 'lodash/keyBy';

import { mapSonarV3Places } from './sonarV3PlacesMapper';

import type {
  MutationAction,
  MutationResponseAction,
  QueryAction,
  QueryResponseAction,
} from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { PlaceStateBookingPanel } from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/placesBookingPanel';

export const INITIAL_STATE: PlaceStateBookingPanel = {
  byEntityId: {},
};

const updatePlaces = (
  state: PlaceStateBookingPanel,
  action: MutationResponseAction | QueryResponseAction,
): PlaceStateBookingPanel => {
  switch (action.payload.type) {
    case SONAR_V3_ALPHA_CREATE_SESSION:
    case SONAR_V3_CREATE_SESSION:
    case SONAR_V3_POLL_ALPHA:
    case SONAR_V3_POLL: {
      if (isSonarV3ErrorPayload(action.payload.response)) {
        return state;
      }

      const places = mapSonarV3Places(action.payload.response.body.legacyPlaces);

      return {
        byEntityId: { ...state.byEntityId, ...keyBy(places, (place) => place.entity_id) },
      };
    }

    default:
      return state;
  }
};

export const placesReducer = (
  state: PlaceStateBookingPanel = INITIAL_STATE,
  action: MutationAction | QueryAction,
): PlaceStateBookingPanel => {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
    case QUERY_RESPONSE_RECEIVED: {
      return updatePlaces(state, action);
    }

    default:
      return state;
  }
};
